import { Directive, ElementRef, Renderer2, Input, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { NgControl } from '@angular/forms';

@Directive({
  selector: '[appHighlightRequired]'
})
export class HighlightRequiredDirective implements OnInit, OnChanges {
  @Input() appHighlightRequired: boolean;

  constructor(private el: ElementRef, private renderer: Renderer2, private control: NgControl) {}

  ngOnInit() {
    this.applyHighlight();

    // here, listen value changes
    this.control.control.valueChanges.subscribe(() => {
      this.applyHighlight();
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['appHighlightRequired']) {
      this.applyHighlight();
    }
  }

  private applyHighlight() {
    const value = this.control.control.value;
    const errors = this.control.control.errors;

    // here, check if the value is required and empty
    const isEmpty = value === null || value === undefined || value === '';
    
    // here, check if the value violates min or max constraints
    const hasMinError = errors?.['min'];
    const hasMaxError = errors?.['max'];

    if (this.appHighlightRequired && (isEmpty || hasMinError || hasMaxError)) {
      this.renderer.addClass(this.el.nativeElement, 'highlight-required');
    } else {
      this.renderer.removeClass(this.el.nativeElement, 'highlight-required');
    }
  }
}